import { Report, Enums } from '@softools/softools-core';

export const getChartType = (report: Report) => {
  return (report.Type === Enums.ReportTypes.Chart || report.Type === Enums.ReportTypes.Matrix) && report.Chart ? report.Chart.ChartType : null;
};
